// @ts-nocheck
import React, {forwardRef, useImperativeHandle, useState} from "react";
import {VisitorCardProps} from "components/member-card/VisitorSlip";
import {useMembershipApplication} from "context/ApplicationContext";
import {useNavigate} from "react-router-dom";
import ApiClient from "rest/ApiClient";
// import Modal from "@mui/material/Modal";
import Modal from "react-modal";
import styled from "@emotion/styled";

const modalStyle = {
	overlay: {
		zIndex: 10,
		background: "rgba(0,0,0,0.25)",
		backdropFilter: "blur(0.8vw)",
		WebkitBackdropFilter: "blur(0.8vw)",
	},
	content: {
		maxWidth: "80%",
		top: "45%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		borderRadius: "1em",
		background:
			" linear-gradient(135deg, rgba(212,212,207,1) 0%, rgba(250,250,240,1) 50%, rgba(217,217, 206,1) 100%)",
		boxShadow: "3px 3px 6px rgba(0,0,0,0.2)",
		boxSizing: 'content-box',
		overflow: "hidden",
		border: "none",
	},
};


const Container = styled.div`
  width: 100%;
	//height: 100%;
	display: flex;
  flex-direction: column;
	align-items: center;
  justify-content: space-evenly;
	gap: 15px;
  //box-sizing: border-box;
	//background: white;
  backdrop-filter: blur(4px);
	border-radius: 16px;
  justify-self: center;
`;

const Title = styled.h1`
	font-size: 1.2em;
	font-weight: 700;
  line-height: 2.1;
`

const PassList = styled.div`
  width: 100%;
	//height: 100%;
	max-height: 270px; // todo: do we need to make this based on screen size?
	display: flex;
  flex-direction: column;
	align-items: center;
  justify-content: space-evenly;
  //box-sizing: border-box;
	overflow-y: auto;
`;

type SlipProps = {
	backgroundColor?: string;
};
export const SlipContainer = styled.div<SlipProps>`
	width: 100%;
	display: flex;
	//flex-direction: column;
	//gap: 1em;
	padding: 2em 1.5em;
	text-align: left;
	
	max-width: calc(var(--root-view-width) * 0.95);
	//max-height: 80%;
	//overflow: scroll;
	
	${({backgroundColor}) => backgroundColor && `background-color: ${backgroundColor};`}

  --mask:
  radial-gradient(22.36px at 50% 30px,#000 99%,#0000 101%) calc(50% - 20px) 0/40px 51% repeat-x,
  radial-gradient(22.36px at 50% -20px,#0000 99%,#000 101%) 50% 10px/40px calc(51% - 10px) repeat-x,
  radial-gradient(22.36px at 50% calc(100% - 30px),#000 99%,#0000 101%) 50% 100%/40px 51% repeat-x,
  radial-gradient(22.36px at 50% calc(100% + 20px),#0000 99%,#000 101%) calc(50% - 20px) calc(100% - 10px)/40px calc(51% - 10px) repeat-x;
  -webkit-mask: var(--mask);
  mask: var(--mask);
	
	> div {
		  display: flex;
      flex-direction: column;
      gap: 0.5em;
			flex-grow: 1;
      > p {
        font-size: 0.9em;
        //line-height: 1.5em;
	    //  font-weight: 500;
      }
    }
  > img {
    width: 100%;
    height: max-content;
  }
`

// const StartNewButton = styled.button`
// 	padding: 10px 20px;
//   border-radius: 10px;
//   background: #4CAF50;
//   color: white;
//   cursor: pointer;
//   transition: background-color 0.3s;
//
//   &:hover {
//     background-color: #45a049;
//   }
// `


const StartNewButton = styled.button`
  appearance: none;
  margin-top: 10px;
  //margin-right: 10px;
  //align-self: end;
  //background: #005dff;
  background: linear-gradient(135deg, #1e34f5, #6026ef);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 22px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
	gap: 4px;
	width: 60%;
	height: 40px;
  transition: opacity 0.1s;
	
  &:active {
    opacity: 0.5;
  }
`;

export type VisitorSession = {
	visitorInfo: VisitorCardProps,
	flowToken?: string,
	nextFlowGuid?: string,
}


const PassRestoreModal = () => {
	let navigate = useNavigate();
	const {appState, setAppState, userInfo, setUserInfo} = useMembershipApplication();

	const [open, setOpen] = useState(true);
	const [prevSessionData, setPrevSessionData] = useState(() => {
		// Load the data from Local Storage if it exists
		const savedData = localStorage.getItem('visitor-session');
		const data = savedData ? JSON.parse(savedData) : [];
		// localStorage.setItem('visitor-session', JSON.stringify(data));

		// only show previous sessions for today
		return data.filter((session : VisitorSession) => {
			// IF WITHIN 24 HOURS
			const last24Hours = new Date().getTime() - 24 * 60 * 60 * 1000;
			return parseInt(session.visitorInfo.visitorIssuedTime) > last24Hours;

			// IF TODAY
			// const visitorDate = new Date(parseInt(session.visitorInfo.visitorIssuedTime));
			// const today = new Date();
			// return visitorDate.getFullYear() === today.getFullYear() && visitorDate.getMonth() === today.getMonth() && visitorDate.getDate() === today.getDate();
		}).sort((a, b) => parseInt(b.visitorInfo.visitorIssuedTime) - parseInt(a.visitorInfo.visitorIssuedTime));
	});

	const tappedSession = (session : VisitorSession) => {
		// console.log("Tapped session:", session);
		setUserInfo({...userInfo, isVisitor: true, visitorInfo: session.visitorInfo });
		setAppState({...appState, flowToken: session.flowToken, nextFlowGuid: session.nextFlowGuid });

    // forward to complete page
		navigate(`/${ApiClient.venueKey}/complete`, { replace: true });
	}

	return (
		<Modal
			isOpen={open && prevSessionData.length > 0}
			style={modalStyle as any}
			shouldCloseOnOverlayClick={true} // todo: fix the issue with the modal not closing when clicked outside of it?
		>
			<Container>
				<Title>Visitor Pass Found</Title>
				<p style={{margin: '-15px 0 -5px 0'}}>Click to view your pass</p>
				<PassList>
					{prevSessionData.map((session : VisitorSession) => {
						const { visitorInfo } = session;
						return (
							<SlipContainer
								key={visitorInfo.visitorId}
								backgroundColor={visitorInfo.backgroundColor}
								onClick={() => tappedSession(session)}
							>
								<div>
									<strong>{visitorInfo.fullName}</strong>
									<p>Entry #{visitorInfo.visitorId}</p>
									<p>Time:  {(new Date(parseInt(visitorInfo.visitorIssuedTime)).toLocaleTimeString('en-AU', { hour12: true }))}</p>
									{/*{ visitorInfo.signatureImgUrl &&*/}
									{/*	(<img src={visitorInfo.signatureImgUrl} alt="Sig" style={{borderRadius: 4}} />)*/}
									{/*}*/}
								</div>
								{ visitorInfo.selfieImgUrl &&
									(<img src={visitorInfo.selfieImgUrl} alt="Sig" style={{borderRadius: 8, maxWidth: '80px'}} />)
								}
							</SlipContainer>
						)
					})}
				</PassList>
				<p style={{margin: '-5px 0 -15px 0'}}>or</p>
				<StartNewButton onClick={() => setOpen(false)}>Start New</StartNewButton>
			</Container>
		</Modal>
	)
}

export default PassRestoreModal;
